import React, { useState } from "react";
import constants from '../../Components/Services/constant';
import Footer from "../../Components/Footer";
import Header from "../../Components/Header";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, EffectFade } from 'swiper/modules';
import { Triangle } from "react-loader-spinner";
import { ApiService } from "../../Components/Services/apiservices";

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';

let apiServices = new ApiService();

function EventsPrivateDining() {
    const [spinnerLoading, setSppinerLoading] = useState(false);
    const [successMessage, setSuccessmessage] = useState("");
    const [pageData, setPageData] = useState({});
    const [roomEnquiryData, setRoomEnquiryData] = useState({
        name: "", email: "", phone: "", from_date: "", to_date: "", members: "", purpose: "",
    });

    React.useEffect(() => {
        const dataString = { page_url: "events-and-private-dining" };
        apiServices.pagePostRequest(dataString)
            .then((res) => {
                if (res.data.status === "success" && res.data.pageData) {
                    setPageData(res.data.pageData);
                }
            })
            .catch((err) => {
                console.error("Error fetching events page data:", err);
            });
    }, []);

    const handleroomchangeData = (e) => {
        const value = e.target.value;
        const key = e.target.name;
        setRoomEnquiryData({ ...roomEnquiryData, [key]: value });
    };

    const submitroomenquiry = () => {
        if (roomEnquiryData.name === "") { document.getElementById("name").style.border = "1px solid red"; return false; }
        else if (roomEnquiryData.email === "") { document.getElementById("email").style.border = "1px solid red"; return false; }
        else if (roomEnquiryData.phone === "") { document.getElementById("phone").style.border = "1px solid red"; return false; }
        else if (roomEnquiryData.members === "") { document.getElementById("members").style.border = "1px solid red"; return false; }

        setSppinerLoading(true);
        const dataString = { ...roomEnquiryData };
        apiServices.roomenquiryPostRequest(dataString).then((res) => {
            if (res.data.status === "success") {
                setSuccessmessage(res.data.message);
                setSppinerLoading(false);
                setTimeout(() => {
                    document.getElementById("roombtn_timeout").click();
                    window.location.href = "/thank-you";
                }, 2000);
            }
        });
    };

    return (
        <div className="events-private-dining homepage2-wrapper about-us-page">
            <Header />
            <style>
                {`
                .epd-banner-responsive {
                background-image: url('${pageData?.page_header_image ? `${constants.IMAGE_URL}${pageData.page_header_image}` : "/assets/img/food/Event-Desktop-Banner.webp"}');
            }
            @media (max-width: 768px) {
                .epd-banner-responsive {
                    background-image: url('${pageData?.metadata?.banner_mobile_image ? `${constants.IMAGE_URL}${pageData.metadata.banner_mobile_image}` : "/assets/img/food/Event-Mobile-Banner.webp"}');
                }
            }
                .epd-btn-quote {
                    background-color: transparent;
                    border: 1px solid #c49a6c;
                    color: #c49a6c;
                    padding: 12px 30px;
                    text-transform: uppercase;
                    letter-spacing: 2px;
                    font-size: 14px;
                    transition: all 0.3s ease;
                }
                .epd-btn-quote:hover {
                    background-color: #c49a6c;
                    color: #fff;
                }
                .epd-carousel .swiper-button-next,
                .epd-carousel .swiper-button-prev {
                    background-color: rgba(0, 0, 0, 0.6) !important;
                    color: #fff !important;
                    width: 50px !important;
                    height: 50px !important;
                    border-radius: 50% !important;
                    display: flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                    margin-top: -25px !important;
                }
                .epd-carousel .swiper-button-next:after,
                .epd-carousel .swiper-button-prev:after {
                    font-size: 20px !important;
                    font-weight: bold !important;
                    line-height: 1 !important;
                    display: flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                }
            `}
            </style>
            <div
                className="banner-header section-padding bg-position-bottom valign bg-img bg-fixed epd-banner-responsive"
                data-overlay-dark="3"
                style={{ backgroundSize: "cover", backgroundPosition: "100%" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 text-center caption mt-90">
                            <h1 dangerouslySetInnerHTML={{ __html: pageData?.metadata?.page_title || 'Events & Private Dining' }} />
                        </div>
                    </div>
                </div>
            </div>

            <section className="our-story-section text-center" style={{ paddingTop: '80px', paddingBottom: '40px' }}>
                <div className="container">
                    <div className="story-text-container-full mb-5">
                        <h2 className="story-title">{pageData?.metadata?.private_dining_title || 'Private Dining'}</h2>
                        <div className="story-divider mx-auto">
                            <span>&#9830;</span>
                            <span>&#9830;</span>
                            <span>&#9830;</span>
                        </div>
                        
                        <div className="story-description" dangerouslySetInnerHTML={{ __html: pageData?.metadata?.private_dining_desc || 'Host an intimate gathering for up to 14 guests in our exclusive Private Dining Room with breathtaking views of the River Thames.' }} />
                    </div>
                    <div className="text-center mb-5">
                        <button data-bs-toggle="modal" data-bs-target="#privateRoomModal" className="btn-story-readmore">
                            Request a Quote
                        </button>
                    </div>
                </div>
                <div className="container-fluid px-0">
                    <div className="story-slider-fullwidth">
                        <picture>
                            <source media="(max-width: 768px)" srcSet={pageData?.metadata?.private_dining_mobile_image ? `${constants.IMAGE_URL}${pageData.metadata.private_dining_mobile_image}` : "/assets/img/food/Event-Private-Dining-Mobile-Banner.webp"} />
                            <img src={pageData?.metadata?.private_dining_image ? `${constants.IMAGE_URL}${pageData.metadata.private_dining_image}` : "/assets/img/food/Event-Private-Dining-Desktop-Banner.webp"} alt="Private Dining Room" className="img-fluid full-width-img" style={{ height: 'auto', width: '100%' }} />
                        </picture>
                    </div>
                </div>
            </section>

            <section className="our-story-section text-center" style={{ paddingTop: '0px', paddingBottom: '20px' }}>
                <div className="container">
                    <div className="story-text-container-full mb-5">
                        <h2 className="story-title">{pageData?.metadata?.events_title || 'Events'}</h2>
                        <div className="story-divider mx-auto">
                            <span>&#9830;</span>
                            <span>&#9830;</span>
                            <span>&#9830;</span>
                        </div>
                        <div className="story-description" dangerouslySetInnerHTML={{ __html: pageData?.metadata?.events_desc || 'Our restaurant is available for exclusive private hire and can accommodate up to 150 guests. The space is suitable for private celebrations, corporate gatherings, group dining, and special occasions, with flexible seating arrangements and curated dining options available.' }} />
                    </div>
                    <div className="text-center mb-5">
                        <button data-bs-toggle="modal" data-bs-target="#privateRoomModal" className="btn-story-readmore">
                            Request a Quote
                        </button>
                    </div>
                </div>
                <div className="container-fluid px-0">
                    <div className="story-slider-fullwidth">
                        <Swiper
                            modules={[Navigation, Autoplay, EffectFade]}
                            navigation
                            effect="fade"
                            autoplay={{ delay: 4000, disableOnInteraction: false }}
                            loop={true}
                            slidesPerView={1}
                            className="epd-carousel"
                        >
                            {/* Carousel Images */}
                            {pageData?.metadata?.events_sliders?.length > 0 ? (
                                pageData.metadata.events_sliders.map((slide, idx) => (
                                    <SwiperSlide key={idx}>
                                        <picture>
                                            <source media="(max-width: 768px)" srcSet={slide.mobile_image ? `${constants.IMAGE_URL}${slide.mobile_image}` : `/assets/img/food/Event-Slider-Mobile-${idx + 1}.webp`} />
                                            <img src={`${constants.IMAGE_URL}${slide.image}`} alt={`Event Slide ${idx + 1}`} className="img-fluid full-width-img" style={{ height: 'auto', width: '100%' }} />
                                        </picture>
                                    </SwiperSlide>
                                ))
                            ) : (
                                <>
                                    <SwiperSlide>
                                        <picture>
                                            <source media="(max-width: 768px)" srcSet="/assets/img/food/Event-Slider-Mobile-1.webp" />
                                            <img src="/assets/img/food/Event-Slider-Desktop-1.webp" alt="Event Slide 1" className="img-fluid full-width-img" style={{ height: 'auto', width: '100%' }} />
                                        </picture>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <picture>
                                            <source media="(max-width: 768px)" srcSet="/assets/img/food/Event-Slider-Mobile-2.webp" />
                                            <img src="/assets/img/food/Event-Slider-Desktop-2.webp" alt="Event Slide 2" className="img-fluid full-width-img" style={{ height: 'auto', width: '100%' }} />
                                        </picture>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <picture>
                                            <source media="(max-width: 768px)" srcSet="/assets/img/food/Event-Slider-Mobile-3.webp" />
                                            <img src="/assets/img/food/Event-Slider-Desktop-3.webp" alt="Event Slide 3" className="img-fluid full-width-img" style={{ height: 'auto', width: '100%' }} />
                                        </picture>
                                    </SwiperSlide>
                                </>
                            )}
                        </Swiper>
                    </div>
                </div>
            </section>

            {/* Request Quote Modal */}
            <div className="modal fade equote" id="privateRoomModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content equote-content text-start">
                        <button type="button" className="btn-close" id="roombtn_timeout" data-bs-dismiss="modal" aria-label="Close"></button>
                        <h3>Private Dining & Events Enquiry</h3>
                        {successMessage !== "" ? (
                            <div className="alert alert-success" role="alert">{successMessage}</div>
                        ) : null}
                        {spinnerLoading === false ? (
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="form-group mb-2">
                                        <label>Name</label>
                                        <input type="text" name="name" id="name" onChange={handleroomchangeData} />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="form-group mb-2">
                                        <label>Email</label>
                                        <input type="email" name="email" id="email" onChange={handleroomchangeData} />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="form-group mb-2">
                                        <label>Phone Number</label>
                                        <input type="number" name="phone" id="phone" onChange={handleroomchangeData} />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="form-group mb-2">
                                        <label>From Date</label>
                                        <input type="date" name="from_date" id="from_date" onChange={handleroomchangeData} />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="form-group mb-2">
                                        <label>To Date</label>
                                        <input type="date" name="to_date" id="to_date" onChange={handleroomchangeData} />
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <div className="form-group mb-2">
                                        <label>No. of Guests</label>
                                        <input type="number" name="members" id="members" onChange={handleroomchangeData} />
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <div className="form-group">
                                        <label>Event Purpose / Details</label>
                                        <textarea name="purpose" id="purpose" onChange={handleroomchangeData}></textarea>
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <div className="butn-dark mt-3">
                                        <button type="button" className="butn-dark-full" onClick={submitroomenquiry}>
                                            <span>Submit Enquiry</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <Triangle width="100%" height="80px" color="#AA8453" ariaLabel="triangle-loading" visible={true} />
                        )}
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
}

export default EventsPrivateDining;
